// extracted by mini-css-extract-plugin
export default {"modal-launch-method-type":"ModalLaunchMethodType_modal-launch-method-type__-K+ZD"};